import { Formik } from 'formik';
import React from 'react';
import {
  DefaultModalProps,
  useOpenModal,
  withLocationStateModal,
} from 'utils/modals';

import { Box, Button, Grid } from '@mui/material';

import { modelPath } from '@libs/helpers/form';
import { ConnectedTextField } from '@libs/ui/components/form/text-field';
import { DefaultModal } from '@libs/ui/components/modals';
import Typography from '@libs/ui/components/typography';

import { MODAL_TYPES } from '../../consts';
import { useInviteHandler } from './hooks';
import { FormModel } from './types';

interface ModalData {
  matchId: string;
}

interface RemoveModalProps extends DefaultModalProps<ModalData> {
  jobId: string;
}

const RemoveModalComponent = ({
  jobId,
  isOpen,
  close,
  modalData,
}: RemoveModalProps) => {
  const jobMatchId = modalData?.matchId || '';
  const { onSubmit, loading } = useInviteHandler({
    jobMatchId,
    jobId,
    onClose: close,
  });

  return (
    <Formik<FormModel> initialValues={{ message: '' }} onSubmit={onSubmit}>
      {({ submitForm }) => {
        return (
          <DefaultModal
            actions={
              <Grid spacing={4} container>
                <Grid xs={6} item>
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={submitForm}
                    disabled={loading}
                  >
                    Decline
                  </Button>
                </Grid>
                <Grid xs={6} item>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="secondary"
                    onClick={close}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            }
            handleClose={close}
            open={isOpen}
            title="You are going to remove a candidate?"
          >
            <Box mt={4} mb={8}>
              <Typography>Please confirm</Typography>
            </Box>
            <Box>
              <ConnectedTextField
                fullWidth
                size="small"
                variant="filled"
                multiline
                label="Message text"
                name={modelPath<FormModel>((m) => m.message)}
                rows={6}
              />
            </Box>
          </DefaultModal>
        );
      }}
    </Formik>
  );
};

export const RemoveModal = withLocationStateModal({ id: MODAL_TYPES.REMOVE })(
  RemoveModalComponent,
);

export const useOnRemoveModal = () =>
  useOpenModal<ModalData>(MODAL_TYPES.REMOVE);
